// 统一错误处理系统的翻译文件

export const unifiedError = {
    // 内容策略相关
    content_policy: '內容不符合平台政策，請修改後重試',
    safety_policy: '內容涉及安全問題，請修改提示詞後重試',
    safety: '內容涉及安全問題，請修改提示詞後重試',
    recitation: '內容可能涉及版權問題，請修改提示詞後重試',
    
    // 資源限制相關
    rate_limit: '請求過於頻繁，請稍後重試',
    credits: '積分不足，請訂閱套餐或購買積分包',
    quota_exceeded: '配額已用完，請稍後重試或升級套餐',
    
    // 生成相關
    no_image: '未能生成圖片，請嘗試修改提示詞或重新生成',
    generation_failed: '生成失敗，請重試',
    prompt_complex: '提示詞過於複雜或包含衝突要求，請簡化後重試',
    GENERATE_PROCESSING: '你有一個正在進行中的生成任務，請稍等',
    timeout: '操作超時，請重試',
    
    // 網絡和服務器相關
    network_error: '網絡連接失敗，請檢查網絡連接',
    server_error: '服務器內部錯誤，請稍後重試',
    auth_error: '身份驗證失敗，請重新登錄',
    not_found: '資源未找到，可能已被刪除',
    api_error: 'API調用失敗，請稍後重試',
    
    // 輸入驗證相關
    invalid_input: '輸入內容無效，請檢查後重試',
    missing_required: '請填寫必填項',
    
    // 通用錯誤
    unknown: '未知錯誤，請稍後重試',
    
    // 通用消息
    general: {
      operationFailed: '操作失敗，請重試',
      tryAgainLater: '請稍後再試',
      contactSupport: '如果問題持續存在，請聯繫客服'
    }
  };
